// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { updateHighlightedPaths } from 'redux/modules/projectSummary'

// toggles the highlight of all visible paths.
// if all visible paths are highlighted, remove em
// otherwise set all visible paths to highlighted.

const toggleAllPathHighlight = () => (dispatch, getState) => {
  const { projectSummary } = getState()
  const highlightedPaths = projectSummary.get('highlightedPaths')
  const visiblePathIds = projectSummary.get('visiblePathIds')

  const updatedHighlightedPaths = (
    highlightedPaths.size !== visiblePathIds.size
      ? visiblePathIds
      : []
  )

  dispatch(updateHighlightedPaths(updatedHighlightedPaths))
}

export default toggleAllPathHighlight
